import React from 'react'

import { BigHead } from '@bigheads/core'

export const ElinaMalina = () => (
  <BigHead
    accessory="roundGlasses"
    body="chest"
    circleColor="blue"
    clothing="shirt"
    clothingColor="red"
    eyebrows="leftLowered"
    eyes="simple"
    faceMask={false}
    faceMaskColor="black"
    facialHair="stubble"
    graphic="react"
    hair="afro"
    hairColor="pink"
    hat="none"
    hatColor="white"
    lashes
    lipColor="pink"
    mask
    mouth="grin"
    skinTone="red"
  />
)

export const Anonymous = () => (
  <BigHead
    accessory="shades"
    body="chest"
    circleColor="blue"
    clothing="shirt"
    clothingColor="white"
    eyebrows="concerned"
    eyes="squint"
    faceMask
    faceMaskColor="black"
    facialHair="none2"
    graphic="graphQL"
    hair="buzz"
    hairColor="black"
    hat="none4"
    hatColor="black"
    lashes
    lipColor="green"
    mask
    mouth="open"
    skinTone="light"
  />
)
